<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pxvii"></a><a class="xref" href="#/chiyearsley0006#toc">ABBREVIATIONS</a></h1>
<div class="glossary">
<p class="glo"><span class="gt">BD</span>—<i>Bach-Dokumente</i>. 5 vols. Edited by Werner Neumann and Hans-Joachim Schulze. Kassel: Bärenreiter, 1963–2007.</p>
<p class="glo"><span class="gt">BWV</span>—Bach-Werke-Verzeichnis. Compiled and edited by Wolfgang Schmieder. <i>Thematisch-Systematisches Verzeichnis der musikalischen Werke von Johann Sebastian Bach</i>, revised and expanded ed. Wiesbaden: Breitkopf &amp; Härtel, 1990.</p>
<p class="glo"><span class="gt">NBA</span>—<i>Johann Sebastian Bach: Neue Ausgabe sämtlicher Werke</i> [complete scholarly edition of the works of J. S. Bach]. 96 volumes, divided into 8 series and a supplement. Kassel: Bärenreiter, 1954–2007.</p>
<p class="glo"><span class="gt">NBR</span>—<i>The New Bach Reader</i>. Edited by Christoph Wolff, Arthur Mendel, and Hans T. David. New York: Norton, 1998.</p>
<p class="glo"><span class="gt">KB</span>—<i>Kritischer Bericht</i> [Critical Report]. Scholarly apparatus provided for each volume of the scores of the NBA.</p>
<p class="glo"><span class="gt">Hübner</span>—<i>Anna Magdalena Bach: Ein Leben in Dokumenten und Bildern</i>. Edited by Maria Hübner. Leipzig: Evangelische Verlagsanstalt, 2004.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-yearsley-0010.vue?aeb5d69e